module.exports = kolibriCoreAppGlobal.coreVue.router;